import { useQuery } from "react-query";
import { getTimeBoundDeliveryStats } from "../apis/bst2Dashboard";

export const useTimeBoundDeliveryStats = (params = {}, { enabled = true } = {}) =>
  useQuery(["bst2_time_bound_delivery_stats", params], () => getTimeBoundDeliveryStats(params), {
    refetchOnWindowFocus: false,
    enabled,
    select: (res) => res?.data,
  });
